// Mock data for AZ Consulting website

export const services = [
  {
    id: 1,
    title: "Seguridad y Salud Ocupacional",
    description: "Garantizamos el cumplimiento normativo en materia de seguridad y salud ocupacional. Realizamos diagnósticos, implementamos sistemas de gestión, capacitamos al personal y elaboramos planes de prevención de riesgos laborales para crear espacios de trabajo seguros y saludables.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Asesoría en Talento Humano",
    description: "Brindamos consultoría estratégica integral en gestión del talento humano, desde el diseño de estructuras organizacionales hasta la implementación de políticas de recursos humanos. Acompañamos a las empresas en la optimización de sus procesos de RRHH para alcanzar sus objetivos de negocio.",
    icon: "Briefcase"
  },
  {
    id: 3,
    title: "Selección de Personal",
    description: "Identificamos y seleccionamos el talento ideal para su organización mediante procesos rigurosos que incluyen análisis de perfiles, evaluaciones psicométricas, entrevistas por competencias y verificación de referencias. Aseguramos la mejor compatibilidad entre el candidato y la cultura organizacional.",
    icon: "UserCheck"
  },
  {
    id: 4,
    title: "Manual de Funciones",
    description: "Elaboramos manuales de funciones y perfiles de cargo detallados que definen claramente responsabilidades, competencias requeridas y líneas de autoridad. Este instrumento fundamental permite una gestión eficiente del talento y facilita procesos de selección, evaluación y desarrollo del personal.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Valoración de Cargos",
    description: "Realizamos estudios técnicos de valoración de cargos para establecer escalas salariales equitativas y competitivas. Mediante metodologías comprobadas, evaluamos factores como responsabilidad, competencias, condiciones de trabajo y complejidad para garantizar una compensación justa y motivadora.",
    icon: "TrendingUp"
  },
  {
    id: 6,
    title: "Análisis de Clima Laboral",
    description: "Medimos y analizamos el clima organizacional para identificar factores que impactan en la satisfacción, compromiso y productividad de los empleados. Proporcionamos diagnósticos precisos y planes de acción concretos para mejorar el ambiente laboral y retener el talento clave.",
    icon: "Activity"
  },
  {
    id: 7,
    title: "Team Building",
    description: "Fortalecemos los equipos de trabajo mediante actividades diseñadas para mejorar la comunicación, colaboración y cohesión grupal. Nuestros programas de team building están personalizados según las necesidades de cada organización, promoviendo un ambiente laboral más productivo y armonioso.",
    icon: "Users"
  },
  {
    id: 8,
    title: "Inteligencia Emocional",
    description: "Desarrollamos las competencias emocionales de los colaboradores para mejorar sus relaciones interpersonales, toma de decisiones y liderazgo. A través de talleres prácticos y coaching, potenciamos la autoconciencia, autorregulación, empatía y habilidades sociales en el entorno laboral.",
    icon: "Heart"
  }
];

export const mockAppointments = [];

export const mockContactSubmissions = [];

export const companyInfo = {
  name: "AZ Consulting",
  email: "rocio@azconsultingec.com",
  phone: "+593 99-423-512",
  address: "Calle de las Begonias y Miguel Angel Edificio Torre Noha",
  experience: "20+"
};